import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-premium";
import { GroupAdministrationState } from "./groupAdministrationTypes";

const initialState: GroupAdministrationState = {
  availableMeasuringPointsSortModel: [
    { field: "substation", sort: "asc" },
    { field: "switchgear", sort: "asc" },
  ],
  availableMeasuringPointsFilterModel: { items: [] },
  assignedMeasuringPointsSortModel: [
    { field: "substation", sort: "asc" },
    { field: "switchgear", sort: "asc" },
  ],
  assignedMeasuringPointsFilterModel: { items: [] },
};

const groupAdministrationSlice = createSlice({
  name: "groupAdministrationSlice",
  initialState,
  reducers: {
    setAvailableMeasuringPointsSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.availableMeasuringPointsSortModel = action.payload;
    },
    setAvailableMeasuringPointsFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.availableMeasuringPointsFilterModel = action.payload;
    },
    setAssignedMeasuringPointsSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.assignedMeasuringPointsSortModel = action.payload;
    },
    setAssignedMeasuringPointsFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.assignedMeasuringPointsFilterModel = action.payload;
    },
  },
});

export const {
  setAvailableMeasuringPointsSortModel,
  setAvailableMeasuringPointsFilterModel,
  setAssignedMeasuringPointsSortModel,
  setAssignedMeasuringPointsFilterModel,
} = groupAdministrationSlice.actions;

export default groupAdministrationSlice.reducer;
